import { FormattedInput } from "@payments-checkout/shared/components";
import { Select } from "@stone-payments/jade";
import { useMemo } from "react";
import { useFormContext } from "react-hook-form";
import { useIntl } from "react-intl";

type StatesInputProps = {
  isError: boolean;
  isStatesLoading: boolean;
  states?: Array<{ name: string; code: string }>;
  disabled?: boolean;
  name?: string;
  onChange?: (event: { target: { value: string } }) => void;
}

export const StatesInput = ({ isError, isStatesLoading, states, disabled, name, onChange, ...rest }: StatesInputProps) => {
  const { formatMessage } = useIntl();

  const {
    register,
    formState: { errors },
  } = useFormContext();

  const stateOptions = useMemo(() => {
    return (
      states?.map((item) => {
        return { label: item.name, value: item.code };
      }) || []
    );
  }, [states]);

  const fieldName = name ?? 'billing-address-state';
  const fieldError = (errors as any)[fieldName];

  if (isError) {
    return (
      <FormattedInput
        formatter="brazilianStates"
        label={formatMessage({ id: 'addressField.state' })}
        error={!!fieldError?.message}
        size="medium"
        placeholder="PR"
        disabled={disabled}
        {...register(fieldName as any, { required: true, onChange })}
      />
    );
  }

  return (
    <Select
      {...rest}
      style={{
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      }}
      options={stateOptions}
      label={formatMessage({ id: 'addressField.state' })}
      disabled={isStatesLoading || disabled}
      error={!!fieldError?.message}
      size="medium"
      supportText={
        fieldError?.message &&
        formatMessage({
          id: `addressFields.validate.${fieldError.message}`,
        })
      }
      placeholder="Escolha uma opção"
      {...register(fieldName as any, { required: true, onChange })}
    />
  )
}
